// extracted by mini-css-extract-plugin
export var circle = "_3s-2";
export var icon = "_3s-a";
export var iconHighlight = "_3s-0";
export var lg = "_3s-8";
export var md = "_3s-7";
export var outline = "_3s-4";
export var sm = "_3s-6";
export var square = "_3s-1";
export var xl = "_3s-9";
export var xs = "_3s-5";
export var xxs = "_3s-3";